const siteConfig = {
  title: 'Guzmán Cura - UX/UI / Product Designer',
  description: 'Product Designer with a UX/UI focus and frontend dev knowledge. I design intuitive, high-impact digital experiences that bridge design and development.',
  siteUrl: 'https://guzmancura.com',
  author: 'Guzmán Cura',
  defaultLanguage: 'en',
  defaultImage: '/og-image.jpg', // Make sure to add this image to your public folder
  keywords: ['UX designer', 'UI designer', 'product designer', 'UX/UI portfolio', 'web designer', 'user experience', 'user interface', 'frontend-aware designer', 'design systems', 'digital product design', 'Guzmán Cura', 'freelance designer', 'UX/UI Montevideo', 'UI expert', 'UX professional', 'Figma', 'UX strategy'],
  social: {
    linkedin: 'https://linkedin.com/in/guzmancura',
  },
};

export const generateMetaTags = (pageMeta = {}) => {
  const meta = {
    ...siteConfig,
    ...pageMeta,
  };

  return {
    // Basic Meta Tags
    title: meta.title,
    description: meta.description,
    keywords: meta.keywords.join(', '),
    author: meta.author,
    language: meta.defaultLanguage,

    // Open Graph Meta Tags
    'og:title': meta.title,
    'og:description': meta.description,
    'og:type': 'website',
    'og:url': meta.siteUrl,
    'og:image': `${meta.siteUrl}${meta.defaultImage}`,
    'og:site_name': meta.title,
    'og:locale': meta.defaultLanguage,

    // Twitter Card Meta Tags
    'twitter:card': 'summary_large_image',
    'twitter:title': meta.title,
    'twitter:description': meta.description,
    'twitter:image': `${meta.siteUrl}${meta.defaultImage}`,

    // Additional Meta Tags
    'robots': 'index, follow',
    'viewport': 'width=device-width, initial-scale=1',
    'theme-color': '#000000',
  };
};

export default siteConfig; 